/* ===== Cart Drawer UI Improvements (2026-02-16) ===== */
(function() {
  'use strict';

  function showCartSuccessMessage() {
    var msg = document.getElementById('cart-drawer-success-msg');
    if (!msg) return;

    msg.classList.remove('is-fading');
    msg.classList.add('is-visible');

    clearTimeout(msg._hideTimer);
    msg._hideTimer = setTimeout(function() {
      msg.classList.add('is-fading');
      setTimeout(function() {
        msg.classList.remove('is-visible', 'is-fading');
      }, 400);
    }, 3000);
  }

  function highlightNewItem() {
    var sidebar = document.getElementById('site-cart-sidebar');
    if (!sidebar) return;

    var items = sidebar.querySelectorAll('.cart-item');
    items.forEach(function(item) {
      item.classList.remove('cart-item--just-added');
    });
    if (items.length > 0) {
      items[0].classList.add('cart-item--just-added');
    }
  }

  // Track whether a new item was just added (set before sidebar opens)
  var itemJustAdded = false;

  document.addEventListener('DOMContentLoaded', function() {

    // Monitor product-form elements for add-to-cart events (non-bubbling)
    function attachFormListeners() {
      document.querySelectorAll('product-form').forEach(function(form) {
        if (!form._cartDrawerListenerAttached) {
          form.addEventListener('add-to-cart', function() {
            itemJustAdded = true;
          });
          form._cartDrawerListenerAttached = true;
        }
      });
    }
    attachFormListeners();

    // Re-attach when DOM changes (e.g., quick view modals)
    var observer = new MutationObserver(function() {
      attachFormListeners();
    });
    observer.observe(document.body, { childList: true, subtree: true });

    // Hook into sidebar show() to display success message
    var sidebar = document.getElementById('site-cart-sidebar');
    if (sidebar && sidebar.show) {
      var origShow = sidebar.show.bind(sidebar);
      sidebar.show = function() {
        origShow();
        if (itemJustAdded) {
          itemJustAdded = false;
          setTimeout(function() {
            showCartSuccessMessage();
            highlightNewItem();
          }, 350);
        }
      };
    }

    // Also handle quick-buy which may use refreshCart
    var origRefreshCart = window.refreshCart;
    if (origRefreshCart) {
      window.refreshCart = function() {
        itemJustAdded = true;
        origRefreshCart();
      };
    }

    // Hide success message when sidebar closes
    if (sidebar) {
      var origHide = sidebar.hide.bind(sidebar);
      sidebar.hide = function() {
        origHide();
        var msg = document.getElementById('cart-drawer-success-msg');
        if (msg) {
          msg.classList.remove('is-visible', 'is-fading');
        }
      };
    }

  });

})();
